import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AppNotificationsService } from '../../services/app-notifications.service';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { KeyValue } from '@angular/common';
import moment from 'moment'
import { UtilService } from '../../services/util.service';
import { NOTIFICATIONS_LIST } from '../../constants/application-constants';
import { SocketService } from '@app/socket.service';
import { ChangeDetectorRef } from '@angular/core';
import { FlagService } from '@app/shared/services/notification.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-notifications',
    templateUrl: './app-notifications.component.html',
    styleUrls: ['./app-notifications.component.css'],
    exportAs: 'menuNotificationComponent',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppNotificationsComponent implements OnInit {
  private readonly notificationService: AppNotificationsService;
  @ViewChild(MatMenu, { static: true }) menu: MatMenu;
  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;
  @ViewChild('notificationMenu') notificationMenu!: MatMenu;
  distance = 2;
  throttle = 50;
  page = 1;
  size = 100;
  hoverActive: boolean = false;
  notifications: any;
  itemIndex = -1;
  itemKey = '';
  checked: boolean = false;
  notificationList = NOTIFICATIONS_LIST;
  notificationsError = false;
  allNotifications: any;

  activeTab: 'personal' | 'duplications' | 'configuration' | 'systemNotification' = 'personal';

  private duplicationEventId: number | null = null;
  duplicationNotifications: any;
  allDuplicationNotifications: any;
  duplicationNotificationsError = false;
  isDuplicationsLoading = false;
  @Input() count!: number;
  @Output() countChange = new EventEmitter<number>();
  previousPage = 0;
  isLoading = false;
  isMenuOpen: boolean = false;

  constructor(
    service: AppNotificationsService,
    private util: UtilService,
    private socketService: SocketService,
    private changeDetector: ChangeDetectorRef,
    private FlagService: FlagService,
    private router: Router
  ) {
    this.notificationService = service;
    this.notificationService.menuEmitter.subscribe(this.toggleMenu.bind(this));
  }

  closeMenuAndNavigate(event: Event): void {
    event.stopPropagation();
    if (this.menuTrigger) {
      this.menuTrigger.closeMenu();
    }
  }

  ngOnInit() {
    this.FlagService.flagFromA.subscribe((flag) => {
      this.getAllNotifications(this.page, this.size, true);
      this.changeDetector.detectChanges();
      console.log("notification bell icon triggered");
    })
    setTimeout(() => {
      this.getAllNotifications(this.page, this.size);
    }, 1500);
    // Subscribe to real-time notifications
    this.socketService.onNewNotification().subscribe((msg: any) => {
      this.handleNewNotification(msg);
    });
  }

  sendToB() {
    this.FlagService.sendFlagFromB(true);
  }

  // Handle new notification received from socket
  handleNewNotification(notification: any) {
    // Make the API call to fetch all notifications again
    this.page = 1;
    this.getAllNotifications(this.page, this.size);
    this.sendToB();
  }

  onScroll(): void {
    if (this.isLoading || !this.isMenuOpen) return;
    this.getAllNotifications(++this.page, this.size);
  }

  handle_no_url(event: Event) {
    event.stopPropagation();
  }

  // New method to handle notification card click
  handleNotificationClick(event: Event, item: any): void {
    event.stopPropagation();
    
    // If notification is unread, mark it as read
    if (!item.is_read) {
      this.markAsRead(event, item.id);
    }
  }

  // New method to handle notification link click
  handleNotificationLinkClick(event: Event, item: any): void {
    event.stopPropagation();
    
    // If notification is unread, mark it as read
    if (!item.is_read) {
      this.markAsRead(event, item.id);
    }
    
    // Close the menu when navigating
    if (this.menuTrigger) {
      this.menuTrigger.closeMenu();
    }

    const route = this.normalizeNotificationRoute(item?.url);
    if (route) {
      this.router.navigateByUrl(route);
    }
  }

  normalizeNotificationRoute(rawUrl: string): string {
    if (!rawUrl || typeof rawUrl !== 'string') {
      return '';
    }

    let normalized = rawUrl.trim();
    if (!normalized) {
      return '';
    }

    try {
      if (/^https?:\/\//i.test(normalized)) {
        const parsed = new URL(normalized);
        normalized = `${parsed.pathname || ''}${parsed.search || ''}${parsed.hash || ''}`;
      }
    } catch (_) {
      // Keep original string when parsing fails
    }

    if (!normalized.startsWith('/')) {
      normalized = `/${normalized}`;
    }

    const legacyQuestionReviewMatch = normalized.match(/\/Library\/Questions\/QuestionUpdateReview\/(\d+)/i);
    if (legacyQuestionReviewMatch?.[1]) {
      return `/Library/QuestionPapers/QuestionPaperVersionReview/${legacyQuestionReviewMatch[1]}?reviewType=question`;
    }

    const [pathOnly, queryString] = normalized.split('?');
    const segments = pathOnly
      .split('/')
      .filter(Boolean)
      .map((segment, index) => {
        const key = segment.toLowerCase();
        if (index === 0 && key === 'library') return 'Library';
        if (index === 1 && key === 'questions') return 'Questions';
        if (index === 1 && key === 'questionpapers') return 'QuestionPapers';
        if (index === 2 && key === 'questionupdatereview') return 'QuestionUpdateReview';
        if (index === 2 && key === 'questionpaperversionreview') return 'QuestionPaperVersionReview';
        return segment;
      });

    const normalizedPath = `/${segments.join('/')}`;
    return queryString ? `${normalizedPath}?${queryString}` : normalizedPath;
  }

 printInitial(username: string): string {
  console.log('Avatar Username:', username);
  const [first, last] = (username || '').trim().split(' ');

  return `${first?.charAt(0)?.toUpperCase() || ''}${
    last?.charAt(0)?.toUpperCase() || ''
  }`;
}

getNotificationAvatarName(item: any): string {
  return (
    item?.metadata?.inputData?.full_name ||
    item?.metadata?.full_name ||
    item?.metadata?.actor_name ||
    item?.sender ||
    'System Notification'
  );
}

  getAllNotifications(page: number, size: number, force: boolean = false) {
    if (!force && this.previousPage === page && this.page != -1) {
      return;
    }
    this.isLoading = true;

    this.notificationService.getNotifications(page, size).subscribe(
      (data: any) => {
        const notifications = data.body.responseBody;
        this.allNotifications = notifications;

        // Extract and print date/time from each notification
        this.extractAndPrintDateTime(this.allNotifications);

        if (this.checked) {
          const list = this.allNotifications.filter((item: any) => !item.is_read);
          this.notifications = this.util.getFormattedNotifications(list);
        } else {
          this.notifications = this.util.getFormattedNotifications(this.allNotifications);
        }

        this.changeDetector.detectChanges();
        this.count = this.allNotifications?.[0]?.unseen_count || 0;
        this.countChange.emit(this.count);
        this.previousPage = page;
        this.isLoading = false;
      },
      (err: any) => {
        this.notificationsError = true;
      }
    );
  }

  // New method to extract and print date/time from notifications
  extractAndPrintDateTime(notifications: any[]) {
    if (!notifications || !Array.isArray(notifications)) {
      return;
    }

    notifications.forEach((notification, index) => {
      // Check different possible date fields
      const possibleDateFields = ['created_datetime', 'created_date', 'timestamp', 'date', 'createdAt', 'sent_date'];

      let foundDate = null;
      for (const field of possibleDateFields) {
        if (notification[field]) {
          foundDate = notification[field];
          break;
        }
      }

      // If no standard date field found, check the message content
      if (!foundDate && notification.message) {
        // Extract date from message using regex patterns
        const datePatterns = [
          /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/, // YYYY-MM-DD HH:mm:ss
          /\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}/, // DD/MM/YYYY HH:mm:ss
          /\d{1,2}\/\d{1,2}\/\d{4}/, // MM/DD/YYYY or DD/MM/YYYY
          /\d{4}-\d{2}-\d{2}/, // YYYY-MM-DD
        ];

        for (const pattern of datePatterns) {
          const match = notification.message.match(pattern);
          if (match) {
            break;
          }
        }
      }
    });
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    this.getAllNotifications(this.page, this.size);
    if (this.activeTab === 'duplications') {
      this.getDuplicationNotifications();
    }
  }

  switchTab(tab: 'personal' | 'duplications' | 'configuration' | 'systemNotification'): void {
    this.activeTab = tab;
    if (tab === 'duplications' && !this.allDuplicationNotifications) {
      this.getDuplicationNotifications();
    }
  }

  getDuplicationNotifications(): void {
    this.isDuplicationsLoading = true;

    if (this.duplicationEventId) {
      this.fetchDuplicationNotifications(this.duplicationEventId);
      return;
    }

    this.notificationService.getDuplicateEventId().subscribe(
      (data: any) => {
        const eventId = data?.body?.responseBody?.event_id;
        if (!eventId) {
          this.duplicationNotificationsError = true;
          this.isDuplicationsLoading = false;
          this.changeDetector.detectChanges();
          return;
        }
        this.duplicationEventId = eventId;
        this.fetchDuplicationNotifications(eventId);
      },
      () => {
        this.duplicationNotificationsError = true;
        this.isDuplicationsLoading = false;
        this.changeDetector.detectChanges();
      }
    );
  }

  private fetchDuplicationNotifications(eventId: number): void {
    this.notificationService.getNotificationsByEventIdsPaginated([eventId], 1, this.size).subscribe(
      (data: any) => {
        const notifications = data.body.responseBody?.data || [];
        this.allDuplicationNotifications = notifications;
        this.duplicationNotifications = this.util.getFormattedNotifications(notifications);
        this.isDuplicationsLoading = false;
        this.changeDetector.detectChanges();
      },
      () => {
        this.duplicationNotificationsError = true;
        this.isDuplicationsLoading = false;
        this.changeDetector.detectChanges();
      }
    );
  }


  handleDuplicationViewDetails(event: Event, item: any): void {
    event.stopPropagation();
    event.preventDefault();

    if (!item.is_read) {
      this.markAsRead(event, item.id);
    }
    if (this.menuTrigger) {
      this.menuTrigger.closeMenu();
    }

    const alertIds = item?.metadata?.alert_ids;
    if (Array.isArray(alertIds) && alertIds.length > 0) {
      this.router.navigateByUrl(`/Library/Questions/DuplicateItems?alert_ids=${alertIds.join(',')}`);
    } else {
      this.router.navigateByUrl('/Library/Questions/DuplicateItems');
    }
  }

  orderOriginal = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return 0;
  };

  getTime(date: any) {
    if (!date) return '';
    const time = moment.utc(date);
    return time.format('YYYY-MM-DD HH:mm:ss');
  }

  getFormattedTime(date: any): string {
    if (!date) return '';
    const notificationTime = moment.utc(date).local();
    return notificationTime.format('MMM DD, HH:mm A');
  }

  onInputChange(event: Event) {
    event.stopPropagation();
    this.checked = !this.checked;

    if (this.checked) {
      const list = this.allNotifications.filter((item: any) => !item.is_read);
      this.notifications = this.util.getFormattedNotifications(list);
    } else {
      this.notifications = this.util.getFormattedNotifications(this.allNotifications);
    }
  }

  // Updated markAsRead method - now specifically for single notifications
  markAsRead(event: any, id?: number) {
    event.stopPropagation();
    
    // Only decrement count if marking a single unread notification
    if (id) {
      const notification = this.allNotifications.find((item: any) => item.id === id);
      if (notification && !notification.is_read) {
        this.count--;
        this.countChange.emit(this.count);
      }
    }
    
    this.notificationService.markAsRead(id).subscribe(
      (data: any) => {
        // Update the specific notification locally
        if (id) {
          const notification = this.allNotifications.find((item: any) => item.id === id);
          if (notification) {
            notification.is_read = true;
          }
        }

        // Reformat the notifications for display
        if (this.checked) {
          const list = this.allNotifications.filter((item: any) => !item.is_read);
          this.notifications = this.util.getFormattedNotifications(list);
        } else {
          this.notifications = this.util.getFormattedNotifications(this.allNotifications);
        }
        this.changeDetector.detectChanges();
      },
      (err: any) => {
        const serviceError = err.responseHead
          ? this.util.getIntlErrorMessage(
            'IN_APP_NOTIFICATIONS',
            err.responseHead.statusCode,
            err.responseHead.statusDesc
          )
          : err;

        this.util.simpleDialog({
          title: 'Error',
          message: serviceError,
        });
      }
    );
    this.sendToB();
  }

  // New method to mark all notifications as read
  markAllAsRead(event: Event) {
    event.stopPropagation();
    
    this.notificationService.markAsRead().subscribe(
      (data: any) => {
        // Mark all notifications as read
        this.allNotifications.forEach((item: any) => {
          item.is_read = true;
        });
        
        this.count = 0; // Reset count to 0
        this.countChange.emit(this.count);

        // Reformat the notifications for display
        if (this.checked) {
          const list = this.allNotifications.filter((item: any) => !item.is_read);
          this.notifications = this.util.getFormattedNotifications(list);
        } else {
          this.notifications = this.util.getFormattedNotifications(this.allNotifications);
        }
        this.changeDetector.detectChanges();
      },
      (err: any) => {
        const serviceError = err.responseHead
          ? this.util.getIntlErrorMessage(
            'IN_APP_NOTIFICATIONS',
            err.responseHead.statusCode,
            err.responseHead.statusDesc
          )
          : err;

        this.util.simpleDialog({
          title: 'Error',
          message: serviceError,
        });
      }
    );
    this.sendToB();
  }
}